import React, { useState, useEffect ,Component } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./ServiceDashboard.css";
import ServiceCart from "./ServiceCart";
const API_URL = "http://localhost:8080/menu";
//const services = [

//   {
//     name: "Medical Services",
//     icon: "🩺",
//     desc: "Doctors, nurses, physiotherapists and healthcare experts.",
//     path: "/home/medicalServices",
//     color: "#00c2a8",
//     options: ["Doctor", "Nurse", "Physio", "Surgeon"]
//   },

//   {
//     name: "Legal Services",
//     icon: "⚖️",
//     desc: "Professional legal support for criminal and civil cases.",
//     path: "/home/lawyerServices",
//     color: "#3b82f6",
//     options: ["Criminal", "Civil", "Corporate"]
//   },

//   {
//     name: "Mechanic Services",
//     icon: "🔧",
//     desc: "Car, bike, AC and machine repair experts.",
//     path: "/home/mechanicServices",
//     color: "#f97316",
//     options: ["Car Repair", "Bike Repair", "AC Repair"]
//   },

//   {
//     name: "Health & Yoga",
//     icon: "💪",
//     desc: "Fitness trainers and yoga instructors.",
//     path: "/home/yogaServices",
//     color: "#22c55e",
//     options: ["Trainer", "Yoga", "Gym Coach"]
//   },

//   {
//     name: "Beauty Care",
//     icon: "💄",
//     desc: "Makeup artists and beauty professionals.",
//     path: "/home/beautyCare",
//     color: "#ec4899",
//     options: ["Makeup", "Hair", "Skin Care"]
//   },

//   {
//     name: "Driver Services",
//     icon: "🚗",
//     desc: "Professional drivers for personal and commercial use.",
//     path: "/home/cabServices",
//     color: "#ef4444",
//     options: ["Car Driver", "Taxi", "Truck Driver"]
//   },

//   {
//     name: "Home Services",
//     icon: "🏠",
//     desc: "Electrician, plumber and cleaner services.",
//     path: "/home/addCareTaker",
//     color: "#8b5cf6",
//     options: ["Plumber", "Electrician", "Cleaner"]
//   },

//   {
//     name: "Event Services",
//     icon: "🎉",
//     desc: "Wedding and party planning experts.",
//     path: "/home/eventServices",
//     color: "#f59e0b",
//     options: ["Wedding", "Party", "Corporate Event"]
//   },

//   {
//     name: "Laundry Services",
//     icon: "🧺",
//     desc: "Laundry, ironing and dry cleaning services.",
//     path: "/home/washingServices",
//     color: "#06b6d4",
//     options: ["Cloth Wash", "Dry Clean", "Iron Service"]
//   },

//   {
//     name: "Travel Services",
//     icon: "✈️",
//     desc: "Travel guides, hotel booking and package services.",
//     path: "/home/tourandtravelServices",
//     color: "#14b8a6",
//     options: ["Hotel", "Tour Guide", "Travel Package"]
//   },

//   {
//     name: "Rental Services",
//     icon: "🏢",
//     desc: "Property rentals and library facilities.",
//     path: "/home/rentalServices",
//     color: "#6366f1",
//     options: ["Property", "Library", "Commercial Space"]
//   },

//   {
//     name: "Education Services",
//     icon: "📚",
//     desc: "Tutors, coaching and online classes.",
//     path: "/home/professionalServices",
//     color: "#9333ea",
//     options: ["Home Tutor", "Coaching", "Online Class"]
//   },

//   {
//     name: "Animal Care",
//     icon: "🐶",
//     desc: "Pet grooming and veterinary support.",
//     path: "/home/addCareTaker",
//     color: "#f43f5e",
//     options: ["Pet Grooming", "Veterinary", "Pet Training"]
//   },

//   {
//     name: "Photography",
//     icon: "📸",
//     desc: "Wedding and professional photography services.",
//     path: "/home/eventServices",
//     color: "#0ea5e9",
//     options: ["Wedding Shoot", "Event Shoot", "Studio Shoot"]
//   },

//   {
//     name: "Construction",
//     icon: "🏗️",
//     desc: "Construction and building maintenance services.",
//     path: "/home/agrofarmServices",
//     color: "#facc15",
//     options: ["Builder", "Painter", "Interior Designer"]
//   },
// //   {
// //   name: "Construction",
// //   icon: "🏗️",
// //   desc: "Construction and building maintenance services.",
// //   path: "/home/agrofarmServices",
// //   color: "#facc15",
// //   options: ["Builder", "Painter", "Interior Designer"]
// // },

// {
//   name: "Child Care Services",
//   icon: "👶",
//   desc: "Professional babysitters, nannies and child support experts.",
//   path: "/home/addCareTaker",
//   color: "#ed5fa9",
//   options: [
//     "Babysitter",
//     "Nanny",
//     "Child Tutor",
//     "Day Care"
//   ]
// },

// {
//   name: "Senior Citizen Care",
//   icon: "🧓",
//   desc: "Trusted elderly care, home nursing and companionship services.",
//   path: "/home/addCareTaker",
//   color: "#14b8a6",
//   options: [
//     "Elderly Care",
//     "Home Nurse",
//     "Companion",
//     "Medical Support"
//   ]
// },

// {
//   name: "Property Care Services",
//   icon: "🏘️",
//   desc: "Property maintenance, security and caretaker management.",
//   path: "/home/addCareTaker",
//   color: "#6366f1",
//   options: [
//     "Property Manager",
//     "Security",
//     "Caretaker",
//     "Maintenance"
//   ]
// }

  // {
  //   name: "Delivery Services",
  //   icon: "📦",
  //   desc: "Fast courier and package delivery services.",
  //   path: "/home/deliveryService",
  //   color: "#10b981",
  //   options: ["Courier", "Food Delivery", "Parcel Delivery"]
  // }
//];

export default function ServiceDashboard() {

 const menuData = [];
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [selectedService, setSelectedService] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
const [serviceList, setServiceList] = useState([]);
 const [loading, setLoading] = useState(false);
const [masterserviceList, setMasterServiceList] = useState([]);
 const [tableData, setTableData] =
     useState([]);




useEffect(() => {
  getAllMAsterSubMenus();
    getAllSubMenus();

 getAllRequestServices()
   
  
  }, []);
  

   

masterserviceList.forEach((item) => {

  const subMenus = serviceList
    .filter(
      (sub) =>
        Number(sub.serviceNameKey) === item.internalKey
    )
    .map(
      (sub) => sub.serviceSubMenuName
    );

  const data = {
    name: item.serviceName,
    icon: item.icon,
    desc: item.description,
    color: item.colour,
    path:
      serviceList.find(
        (sub) =>
          Number(sub.serviceNameKey) === item.internalKey
      )?.url || "",
    options: subMenus,
  };

  menuData.push(data);
});

     const filtered = menuData.filter((s) =>
    s.name.toLowerCase().includes(search.toLowerCase())
  );  
  const getAllSubMenus = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${API_URL}/getSubMenu`
      );

      setServiceList(response.data || []);
    } catch (error) {
      console.error(error);
      alert("Failed to load data");
    } finally {
      setLoading(false);
    }
  };
const getAllRequestServices =
    async () => {

      try {

        const response =
          await axios.get(
            `http://localhost:8080/api/service/getRequestForServiceBasedOnPId/${sessionStorage.getItem('consumerorprovideId')}`,
            {
              headers: {
                env: "local",
                token:
                  sessionStorage.getItem(
                    "token"
                  )
              }
            }
          );
        if (
          response.data.responseData &&
          response.data.responseData.length > 0
        ) {
console.log("response data=>",response);
          setTableData(
            response.data.responseData
          );

        } else {

          setTableData([]);

        }

      } catch (error) {

        console.log(
          "GET ALL ERROR:",
          error
        );

      }

    };
const images = require.context(
  "../../../images",
  false,
  /\.(png|jpe?g|svg|webp)$/i
);

const getImage = (serviceName) => {
  try {
    const fileName = serviceName.toLowerCase();
    return images(`./${fileName}.jpg`);
  } catch (err) {
    return "";
  }
};

 const getAllMAsterSubMenus = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${API_URL}/getMenu`
      );

      setMasterServiceList(response.data || []);

      
    } catch (error) {
      console.error(error);
      alert("Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  return (

    <div className="ultra-dashboard">

      {/* HEADER */}
      <div className="header">

        <h1>
          🚀 Professional Service Hub  &nbsp; <span className="serviceRequest"> {<ServiceCart data={tableData} />}</span>
        </h1>

        <p>
          Find trusted professionals for every service category
        </p>

      </div>

      {/* SEARCH */}
     {/* SEARCH */}
<div className="searchWrapper">

  <input
    className="searchBox"
    placeholder="Search services..."
    onChange={(e) => setSearch(e.target.value)}
  />

</div>

{/* GRID */}
{/* <div className="grid">

  {filtered
    .sort((a, b) =>
      a.name.localeCompare(b.name)
    )
    .map((s, i) => (

      <div
        key={i}
        className="card"
        style={{ "--clr": s.color }}
        onClick={() => {
          setSelectedService(s);
          setSelectedOption("");
        }}
      >

        <div className="cardGlow"></div>

        <div className="iconCircle">
          {s.icon}
        </div>

        <h2 className="cardTitle">
          {s.name}
        </h2>

        <p className="cardDesc">
          {s.desc}
        </p>

      </div>

    ))}

</div> */}


<div className="grid">
  {filtered
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((s, i) => (
      <div
        key={i}
        className="card"
        style={getImage(s.name) === "" ?{ "--clr": s.color }:{
          "--clr": s.color,
          backgroundImage: `url("${getImage(s.name)}")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        onClick={() => {
          setSelectedService(s);
          setSelectedOption("");
        }}
      >
        <div className="cardGlow"></div>

        <div className="iconCircle">
          {s.icon}
        </div>

        <h2 className="cardTitle">{s.name}</h2>

        <p className="cardDesc">{s.desc}</p>
      </div>
    ))}
</div>
      {/* POPUP */}
      {selectedService && (

        <div
          className="popupOverlay"
          onClick={() => setSelectedService(null)}
        >

          <div
            className="popupCard"
            style={{
              background: `linear-gradient(135deg, ${selectedService.color}, #111827)`
            }}
            onClick={(e) => e.stopPropagation()}
          >

            {/* TOP */}
            <div className="popupTop">

              <div className="popupIcon">
                {selectedService.icon}
              </div>

              <h2 className="popupTitle">
                {selectedService.name}
              </h2>

              <p className="popupDesc">
                Select a service type to continue with registration form.
              </p>

            </div>

            {/* OPTIONS */}
            <div className="radioGroup">

              {selectedService.options.map((opt, i) => (

                <label
                  key={i}
                  className={`radioCard ${
                    selectedOption === opt
                      ? "active"
                      : ""
                  }`}
                  onClick={() => setSelectedOption(opt)}
                >

                  <input
                    type="radio"
                    name="serviceOption"
                  />

                  <span className="radioEmoji">
                    {selectedService.icon}
                  </span>

                  <span>
                    {opt}
                  </span>

                </label>
              ))}

            </div>

            {/* BUTTON */}
            <button
              className="popupBtn"
              disabled={!selectedOption}
              onClick={() =>
                navigate(selectedService.path, {
                  state: {
                    service: selectedService.name,
                    type: selectedOption
                  }
                })
              }
            >

              🚀 Open Form
              {selectedOption
                ? ` (${selectedOption})`
                : ""}

            </button>

          </div>

        </div>
      )}

    </div>
  );
}